import { useState } from "react";

import { ConfirmModal } from "@/components/ConfirmModal/ConfirmModal";
import { RefreshCcw01Icon } from "@/components/Icons/RefreshCcw01Icon";
import { FormField } from "@/design-system/FormField";
import { IconButton } from "@/design-system/IconButton";
import { Input } from "@/design-system/Input";

interface LocationCodeFieldProps {
  value?: string;
  label: string;
  refreshLabel: string;
  modalTitle: string;
  modalDescription: string;
  confirmLabel: string;
  cancelLabel: string;
  isRefreshing: boolean;
  onRefresh: () => Promise<unknown>;
}

export function LocationCodeField({
  value,
  label,
  refreshLabel,
  modalTitle,
  modalDescription,
  confirmLabel,
  cancelLabel,
  isRefreshing,
  onRefresh,
}: LocationCodeFieldProps): React.ReactNode {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <FormField label={label}>
        <Input
          data-testid="location-code-input"
          value={value ?? ""}
          readOnly
          width="full"
          postfix={
            <IconButton
              type="button"
              variant="ghostPrimary"
              size="sm"
              title={refreshLabel}
              onClick={() => setIsModalOpen(true)}
              icon={<RefreshCcw01Icon />}
            />
          }
        />
      </FormField>
      <ConfirmModal
        tone="warning"
        data-testid="location-code-modal"
        title={modalTitle}
        description={modalDescription}
        isOpened={isModalOpen}
        onOpenChange={setIsModalOpen}
        shouldCloseOnEsc
        onReject={() => setIsModalOpen(false)}
        rejectBtnProps={{ text: cancelLabel }}
        onResolve={async () => {
          await onRefresh();
          setIsModalOpen(false);
        }}
        resolveBtnProps={{ text: confirmLabel }}
        isLoading={isRefreshing}
      />
    </>
  );
}
